import { Component, createRef } from 'react';
import { NSARouterMakerResult } from 'namirasoft-account-react';
import { TemplateGenerator, TemplateRow } from 'namirasoft-password';
import { NSBox, NSBoxEntity, NSBoxSensitive, NSButtonBlue, NSColumn, NSPanel } from 'namirasoft-site-react';
import { PasswordLayout } from '../PasswordLayout';
import { PasswordRouterProps } from '../PasswordRouterProps';
import { DefaultTemplates } from '../DefaultTemplates';

export interface PasswordGeneratePageProps extends NSARouterMakerResult, PasswordRouterProps { }

export interface PasswordGeneratePageState
{
    generated_password: string | null;
}

class PasswordGeneratePage extends Component<PasswordGeneratePageProps, PasswordGeneratePageState>
{
    private NSBoxEntity_Template = createRef<NSBoxEntity<TemplateRow>>();
    private NSBoxSensitive_Password = createRef<NSBoxSensitive>();

    constructor(props: PasswordGeneratePageProps)
    {
        super(props);
        this.state = { generated_password: null };
        this.generate = this.generate.bind(this);
    }

    generate()
    {
        try
        {
            let template = this.NSBoxEntity_Template.current?.getDataOne();
            if (template)
            {
                let generated_password = TemplateGenerator.generate(template)
                this.setState(
                    () => ({ generated_password }),
                    () => this.NSBoxSensitive_Password.current?.setValue(generated_password),
                )
            }
        }
        catch (error)
        {
            this.props.notifier.onError(error as string)
        }
    }

    override render()
    {
        return (
            <PasswordLayout
                {...this.props}
                action={{
                    title: "Generate Password"
                }}
            >
                <NSColumn classList={["align-items-center"]}>
                    <NSPanel>
                        <NSBoxEntity<TemplateRow>
                            ref={this.NSBoxEntity_Template}
                            title="Template"
                            table_name="template"
                            list={async (filters, page, size, sorts) =>
                            {
                                try
                                {
                                    const res = await this.props.servers.password.template.List(filters, page, size, sorts, null);
                                    if (res.count > 0)
                                        return res;
                                    else
                                        return { rows: DefaultTemplates, count: DefaultTemplates.length }
                                }
                                catch
                                {
                                    return { rows: DefaultTemplates, count: DefaultTemplates.length }
                                }
                            }}
                            required
                            multiple={false}
                            getValue={(item) => item.id}
                            getTitle={(item) => item.name}
                            getSort={() => null}
                            style={{ width: NSBox.width.double }}
                            onChanged={this.generate}
                        />
                    </NSPanel>
                    {
                        this.state.generated_password &&
                        <NSPanel>
                            <NSBoxSensitive
                                ref={this.NSBoxSensitive_Password}
                                title="Password"
                                required={false}
                                style={{ width: NSBox.width.double }}
                                auto_complete='new-password'
                                menu={{
                                    items: [],
                                    builtin: {
                                        copy: {
                                            enabled: true,
                                            getValue: () => this.state.generated_password ?? ""
                                        }
                                    },
                                }}
                            />
                            <NSButtonBlue
                                title="Regenerate"
                                onClick={{
                                    showLoading: false,
                                    action: this.generate,
                                }}
                            />
                        </NSPanel>
                    }
                </NSColumn>
            </PasswordLayout>
        )
    }
}

export default PasswordGeneratePage